import { render, staticRenderFns } from "./MessageContentEditor.vue?vue&type=template&id=bdd8f0a6&"
import script from "./MessageContentEditor.vue?vue&type=script&lang=js&"
export * from "./MessageContentEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports